import { BotaoComTexto } from '@digix-ui/componentes'
import clsx from 'clsx'
import { useMemo } from 'react'
import { NavLink, Outlet } from 'react-router-dom'

import { SinoDeNotificacoes } from '@/components/features/notificacoes/SinoDeNotificacoes'
import { obterRotaDeMenuItemCadastros } from '@/config'
import { useAuth, useFeatureFlag } from '@/hooks'
import { abrirPoliticaDePrivacidade, abrirTermosDeUso } from '@/services/termos'

import classes from './styles.module.scss'
import type { LayoutMenuItem } from './types'

export function AppLayout(): JSX.Element {
  const {
    nome,
    is_admin,
    permissao_para_parametrizar_campos_da_integracao,
    deslogar,
  } = useAuth()

  const integracaoPapelZeroHabilitada = !!useFeatureFlag(
    'integracao_papel_zero'
  )

  const memoMenuItems: LayoutMenuItem[] = useMemo(() => {
    const menuItems = [
      {
        id: 'documentos',
        path: '/app/documentos',
        nome: 'Documentos',
        filtro: 'documentos',
      },
    ] as LayoutMenuItem[]

    const rota = obterRotaDeMenuItemCadastros(
      integracaoPapelZeroHabilitada,
      permissao_para_parametrizar_campos_da_integracao
    )

    if (rota) {
      menuItems.push({
        id: 'cadastros',
        path: rota,
        nome: 'Cadastros',
        filtro: 'cadastros',
      })
    }
    return menuItems
  }, [
    integracaoPapelZeroHabilitada,
    permissao_para_parametrizar_campos_da_integracao,
  ])

  return (
    <>
      <header className="cabecalho-sistema">
        <div className="cabecalho-sistema__container-primario">
          <NavLink to="/app/documentos" className={classes.botaoLogo} replace>
            <img
              className={clsx('cabecalho-sistema__logo', classes.icone)}
              width="33"
              src="/assets/images/logo-horus-branco.svg"
              alt="Logotipo do Horus"
            />
          </NavLink>
          <nav className="cabecalho-sistema__menu" aria-label="Menu principal">
            <ul className="cabecalho-sistema__lista-de-itens">
              {memoMenuItems.map(menuItem => (
                <li key={menuItem.id}>
                  <NavLink
                    className={({ isActive }) =>
                      clsx('cabecalho-sistema__item-de-menu', {
                        'cabecalho-sistema__item-de-menu_ativo': isActive,
                      })
                    }
                    to={menuItem.path}
                  >
                    {menuItem.nome}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        <div className="cabecalho-sistema__container-secundario">
          <nav className="cabecalho-sistema__menu" aria-label="Menu secundário">
            <ul className="cabecalho-sistema__lista-de-itens">
              <SinoDeNotificacoes />

              <li className="dropdown dropdown_direita">
                <button
                  type="button"
                  className="cabecalho-sistema__item-de-menu"
                  aria-label="Opções para o usuário Administrador"
                  aria-haspopup="true"
                >
                  <span className="cabecalho-sistema__icone-do-usuario">
                    <i className="far fa-user" />
                  </span>
                  <span
                    className={clsx(
                      'cabecalho-sistema__nome-do-usuario',
                      classes.nomeUsuario
                    )}
                  >
                    {nome}
                  </span>
                  <i className="far fa-angle-down u-margem-esquerda-pequena" />
                </button>
                <ul
                  className={clsx('dropdown__lista', classes.submenu)}
                  aria-label="Submenu"
                >
                  {is_admin && (
                    <li className="dropdown__item">
                      <NavLink
                        className={clsx(classes.dropdownLink, 'dropdown__link')}
                        to="/app/configuracoes"
                        replace
                      >
                        <i className="fa-regular fa-gear dropdown__icone" />
                        Configurações
                      </NavLink>
                    </li>
                  )}

                  <li className="dropdown__item">
                    <BotaoComTexto
                      classesAuxiliares="dropdown__link"
                      visual="sem-preenchimento"
                      onClick={abrirPoliticaDePrivacidade}
                      cor="terciaria"
                    >
                      <i className="fa-regular fa-file-lines dropdown__icone" />
                      Política de Privacidade
                    </BotaoComTexto>
                  </li>

                  <li className="dropdown__item">
                    <BotaoComTexto
                      classesAuxiliares="dropdown__link"
                      visual="sem-preenchimento"
                      onClick={abrirTermosDeUso}
                      cor="terciaria"
                    >
                      <i className="fa-regular fa-file-lines dropdown__icone" />
                      Termo de Uso
                    </BotaoComTexto>
                  </li>

                  <li className="dropdown__item">
                    <BotaoComTexto
                      classesAuxiliares="dropdown__link"
                      visual="sem-preenchimento"
                      onClick={() => deslogar()}
                      cor="terciaria"
                    >
                      <i className="far fa-sign-out dropdown__icone" />
                      Sair
                    </BotaoComTexto>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <Outlet />
    </>
  )
}
